import type { FC } from 'react'

export const Title: FC = () => null
